import { z } from 'zod';
import { slugSchema } from './common.js';
export const postStatusSchema = z.enum(['DRAFT', 'PUBLISHED']);
/**
 * Content is TipTap JSON. We don't validate its internal shape here —
 * just require it to be an object so the API can store and retrieve it
 * losslessly.
 */
export const tiptapContentSchema = z
    .record(z.unknown())
    .or(z.object({ type: z.string() }).passthrough());
export const blogPostCreateSchema = z.object({
    slug: slugSchema,
    title: z.string().min(1).max(200).trim(),
    excerpt: z.string().min(1).max(500).trim(),
    content: tiptapContentSchema,
    status: postStatusSchema.default('DRAFT'),
});
export const blogPostUpdateSchema = blogPostCreateSchema.partial();
export const blogPostSchema = z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string(),
    excerpt: z.string(),
    content: tiptapContentSchema,
    status: postStatusSchema,
    publishedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const blogPostSummarySchema = blogPostSchema.omit({ content: true });
//# sourceMappingURL=blog.js.map